import { render, staticRenderFns } from "./assignDetails.vue?vue&type=template&id=63ef0dfd&scoped=true&"
import script from "./assignDetails.vue?vue&type=script&lang=js&"
export * from "./assignDetails.vue?vue&type=script&lang=js&"
import style0 from "./assignDetails.vue?vue&type=style&index=0&id=63ef0dfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef0dfd",
  null
  
)

export default component.exports